// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCambioCategoriaTropa = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'cambio_categoria',
        name: 'Cambio Categoria Por Tropa',
        component: ViewCambioCategoriaTropa,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
